<template>
    <row>
        <column align="center" cols="full">
            <img src="@/assets/logos/cambridge_psychometrics.png" alt="cambridge logo"  width="450px">
<!--            <img src="@/assets/logos/cambridge.svg" width="85px">-->
<!--            <divider class="xs:mt-8 xs:mb-4 sm:my-10" color="primary" width="56px"></divider>-->
<!--            <div class="text-secondary poppins-bold tracking-normal w-full text-center leading-higher xs:text-3xl sm:text-5xl">-->
<!--                University of Cambridge-->
<!--            </div>-->
            <div class="text-center mt-8 text-secondary tracking-normal leading-snug xs:text-2xl sm:text-xl">
                fitt proudly partners with the University of Cambridge Psychometrics Centre.
                <br>
                This enables:
            </div>
        </column>
        <column class="xs:mt-8 sm:mt-16" cols="full">
            <row class="sm:flex-no-wrap" justify="center">
                <column xs="5/6" md="2/6" class="xs:pb-4 sm:pb-0 sm:mr-5 sm:items-end">
                    <row align="center" class="xs:justify-start sm:justify-end" no-wrap>
                        <column>
                            <btn class="mr-4" fab size="71">
                                <icon color="primary" icon="check-all"></icon>
                            </btn>
                        </column>
                        <column class="tracking-normal leading-tight text-secondary sm:pr-10">
                            <div class="text-left">
                            Scientific validation of the fitt platform
                            <br>
                            in line with international best practice
                            </div>
                        </column>
                    </row>
                </column>
                <column xs="5/6" md="2/6" class="sm:ml-5">
                    <row align="center" class="xs:justify-start sm:justify-start" no-wrap>
                        <column>
                            <btn class="mr-4" fab size="71">
                                <icon color="primary" icon="trending-up" size="lg"></icon>
                            </btn>
                        </column>
                        <column class="tracking-normal leading-tight text-secondary">
                            <div class="text-left">
                            Positioning of the fitt platform as an intuitive
                            <br>
                            career planning and learning journey
                            </div>
                        </column>
                    </row>
                </column>
            </row>
            <row class="mt-12 text-secondary text-center tracking-normal leading-snug text-secondary xs:text-2xl sm:text-xl" justify="center">
                Candidates who successfully complete eligible fitt journeys, receive certificates of confirmation.
            </row>
        </column>
    </row>
</template>

<script>
    export default {
        components: {
            // 'divider': () => import('@/components/Divider.vue'),
            'btn': () => import('@/components/Btn.vue'),
            'icon': () => import('@/components/display/Icon.vue'),
        },
    };
</script>
